import React from 'react';
import { Link } from 'react-router-dom';
import { Store } from 'lucide-react';
import { CreatorBadges } from './VerifiedBadge';

export const StoreCard = ({ store }) => {
  return (
    <Link 
      to={`/store/${store.id}`}
      className="group card-brutal overflow-hidden animate-fade-in"
      data-testid={`store-card-${store.id}`}
    >
      <div className="relative h-32 overflow-hidden rounded-xl bg-gradient-to-br from-pastel-crochet/50 via-pastel-stickers/50 to-pastel-art/50">
        {store.banner_image ? (
          <img 
            src={store.banner_image} 
            alt={store.name}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Store className="w-12 h-12 text-foreground/30" />
          </div>
        )}
        
        {/* Badges */}
        {(store.is_founding_creator || store.is_verified || store.tier) && (
          <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full bg-background/80 backdrop-blur">
            <CreatorBadges 
              isVerified={store.is_verified}
              isFoundingCreator={store.is_founding_creator}
              tier={store.tier}
              endorsements={store.endorsement_count}
              size="sm"
            />
          </div>
        )}
        
        {/* Logo */}
        <div className="absolute -bottom-6 left-4 w-16 h-16 rounded-xl border-4 border-card bg-card overflow-hidden shadow-brutal-sm">
          {store.logo ? (
            <img src={store.logo} alt="" className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-pastel-keyrings/30">
              <Store className="w-6 h-6" />
            </div>
          )}
        </div>
      </div>

      <div className="pt-8 px-2">
        <h3 className="font-heading font-bold text-lg line-clamp-1 group-hover:text-pastel-art transition-colors">
          {store.name}
        </h3>
        <p className="text-sm text-muted-foreground line-clamp-2 mt-1">
          {store.description}
        </p>
      </div>
    </Link>
  );
};
